import { render, staticRenderFns } from "./UserListTab.vue?vue&type=template&id=668aad7f&scoped=true"
import script from "./UserListTab.vue?vue&type=script&lang=js"
export * from "./UserListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668aad7f",
  null
  
)

export default component.exports